if (!customElements.get('kol-reviews')) {
  class KolReviews extends HTMLElement {
    constructor() {
      super();
      this._swiperContainer = null;
      this._swiperInstance = null;
    }

    connectedCallback() {
      requestAnimationFrame(() => {
        this._swiperContainer = this.querySelector('.swiper');
        const disableSwiper = this._swiperContainer.classList.contains('swiper--disabled');
        if(!disableSwiper) {
          this.initializeSwiper();
        }
      });
    }

    initializeSwiper() {
      if (!this._swiperContainer) {
        console.error('Swiper container not found');
        return;
      }

      const nextButton = this.querySelector('.swiper-btn-next');
      const prevButton = this.querySelector('.swiper-btn-prev');
      const pagination = this.querySelector(`.swiper-pagination`);

      this._swiperInstance = new Swiper(this._swiperContainer, {
        slidesPerView: 1.1,
        spaceBetween: 16,
        watchSlidesVisibility: true,
        watchOverflow: true,
        direction: "horizontal",
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
        breakpoints: {
          320: {
            slidesPerView: 1.2,
            spaceBetween: 16,
          },
          590: {
            slidesPerView: 2.3,
            spaceBetween: 16,
          },
          769: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1100: {
            slidesPerView: 3,
            spaceBetween: 32,
          },
        }
      });
    }
  }

  customElements.define('kol-reviews', KolReviews);
}